module.exports = "/img/_/_/_/assets/images/avatar/full_right/female//rogue.jpg?caecb296027512f383661da2dc99f434";